import { createFileRoute } from '@tanstack/react-router';
import { ExamPortal } from '@/features/mockExams/guest/ExamPortal';
export const Route = createFileRoute('/exam-portal/')({ component: ExamPortal });
